export const inspectTable = [
  {
    id: 1,
    content: '현장에서 임의 제작한 사다리를 사용하지는 않는가?',
    is_checked: ''
  },
  {
    id: 2,
    content: '사다리의 하부는 미끄러짐 방지장치 또는 아웃트리거를 설치하여 사용하는가?',
    is_checked: ''
  },
  {
    id: 3,
    content: '사다리의 상단은 걸쳐놓은 지점으로부터 60㎝ 이상 걸쳐 놓았는가?',
    is_checked: ''
  },
  {
    id: 4,
    content: '사다리의 기울기는 75° 이하로 세워 작업하는가?',
    is_checked: ''
  },
  {
    id: 5,
    content: '이동통로에 작업자 및 장애물의 유무를 확인하고 사다리를 이동시키는가?',
    is_checked: ''
  },
  {
    id: 6,
    content: '사다리 발판의 간격은 25~30㎝, 폭은 30㎝ 이상으로 되어 있는가?',
    is_checked: ''
  },
  {
    id: 7,
    content: '사다리 발판에서의 미끄러질 위험은 없는가?',
    is_checked: ''
  },
  {
    id: 8,
    content: '계단식 사다리 사용 시 철물 등을 사용하여 견고하게 고정하는가?',
    is_checked: ''
  },
  {
    id: 9,
    content: '안전모(턱끈 조임) 등 개인보호구를 착용하고 작업하는가?',
    is_checked: ''
  },
  {
    id: 10,
    content: '2인 이상이 공동으로 작업하는가?',
    is_checked: ''
  },
]
